import { render, staticRenderFns } from "./DraftSearch.vue?vue&type=template&id=5fcd1baa&scoped=true"
import script from "./DraftSearch.vue?vue&type=script&lang=js"
export * from "./DraftSearch.vue?vue&type=script&lang=js"
import style0 from "./DraftSearch.vue?vue&type=style&index=0&id=5fcd1baa&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fcd1baa",
  null
  
)

export default component.exports